/**
 * Refresh 11b: Editorial Review — refresh-pipeline twin of Stage 6b.
 * Same flag-only critic and pause behavior; reuses the review report renderer.
 */
import React from 'react';
import { StagePanel } from '../StagePanel';
import { renderReviewOutput } from './Stage6bEditorialReviewV2';

export function RefreshEditorialReviewV2() {
  return (
    <StagePanel
      stageId="refresh_11b_editorial_review"
      title="Refresh 11b: Editorial Review"
      description="Flag-only critic for the refreshed article: verifies claims against the refresh research and flags unsourced statistics, fact drift, and LLM-tell phrasing before the live post is updated. It never edits and never pauses the run — auto-fix flags go to Final Polish; factual flags surface here and on the publish panel for your review before updating the live post."
      isLlmStage
      renderOutput={renderReviewOutput}
    />
  );
}
